import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  form: any | FormGroup;
  formSubmit = false;
  userData: any;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.userData = JSON.parse(sessionStorage.getItem('userCreds')!)

    this.form = this.fb.group({
      password: ['',[Validators.required]],
      newPassword: ['',[Validators.required]],
      confirmPassword: ['',[Validators.required]]
    })
  }

  ChangePassword(){
    this.formSubmit = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }

    if(String(this.form.get('newPassword').value) != String(this.form.get('confirmPassword').value)){
      this.toastr.error("The new password and confirm password did not match.");
      return
    }
    let body = {
      "userPhone": String(this.userData.userMobileNo),
      "password": String(this.form.get('password').value),
      "newPassword": String(this.form.get('newPassword').value),
      "confirmPassword": String(this.form.get('confirmPassword').value),
      "cid": Number(sessionStorage.getItem('cid'))
    }

    console.log(body)
    this.generic_service.addChangePassword(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.formSubmit = false;
        this.toastr.success(response.response);
        this.logout()
        this.form.reset()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.message);

      }
    )
  }

  logout(){
    localStorage.clear()
    sessionStorage.clear()
    window.location.href = "/login"
  }

}
